import RoomDetail from "@/components/RoomDetail";

const SingleRoom = () => {
  return <RoomDetail roomType="single" />;
};

export default SingleRoom;